import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link, withRouter } from "react-router-dom";
import { useSignIn } from 'react-auth-kit';
import PublicNavigation from '../components/Navigation/PublicNavigation';

const Signup = ({ history, location }) => {
    const signIn = useSignIn();
    const [formData, setFormData] = useState({
        companyName: '',
        companyLegalName: '',
        companyDomain: '',
        companyTaxId: '',
        companyAddress: '',
        companyPhone: '',
        companyEmail: '',
        companyWebsite: '',
        companyIndustry: '',
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        phone: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [signupSuccess, setSignupSuccess] = useState(false);
    const [registeredEmail, setRegisteredEmail] = useState('');
    const [resendLoading, setResendLoading] = useState(false);
    const [resendMessage, setResendMessage] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleResendVerification = async () => {
        setResendLoading(true);
        setResendMessage('');

        const apiUrl = process.env.REACT_APP_URL;

        try {
            const response = await axios.post(`${apiUrl}/companies/resend-verification`, {
                email: registeredEmail
            });
            setResendMessage(response.data.message || 'Correo de verificación reenviado exitosamente.');
        } catch (err) {
            setResendMessage(err.response?.data?.error || 'Error al reenviar el correo.');
        } finally {
            setResendLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Las contraseñas no coinciden');
            return;
        }

        if (formData.password.length < 8) {
            setError('La contraseña debe tener al menos 8 caracteres');
            return;
        }

        setLoading(true);

        const apiUrl = process.env.REACT_APP_URL;

        const data = {
            'company_name': formData.companyName,
            'company_legal_name': formData.companyLegalName,
            'company_domain': formData.companyDomain,
            'company_tax_id': formData.companyTaxId,
            'company_address': formData.companyAddress,
            'company_phone': formData.companyPhone,
            'company_email': formData.companyEmail,
            'company_website': formData.companyWebsite,
            'company_industry': formData.companyIndustry,
            'email': formData.email,
            'password': formData.password,
            'first_name': formData.firstName,
            'last_name': formData.lastName,
            'phone': formData.phone
        };

        axios({
            method: 'POST',
            url: apiUrl + '/companies/signup',
            data: data
        }).then(response => {
            console.log(response);
            const responseData = response.data;

            setLoading(false);

            // Check if verification is required (new flow)
            if (responseData.requires_verification) {
                setSignupSuccess(true);
                setRegisteredEmail(formData.email);
            }
            // Fallback for old flow with auto-login
            else if (responseData.tokens && responseData.tokens.access_token) {
                signIn({
                    token: responseData.tokens.access_token,
                    expiresIn: 604800,
                    tokenType: "Bearer",
                    authState: {
                        email: data.email,
                        company: responseData.company,
                        admin_user: responseData.admin_user
                    },
                    refreshToken: responseData.tokens.refresh_token
                });

                setTimeout(() => {
                    history.push('/flotilla');
                }, 100);
            } else {
                setError('El registro falló. Por favor, inténtalo de nuevo.');
            }
        })
        .catch(error => {
            console.log(error);
            setLoading(false);

            if (error.response && error.response.data) {
                let errorData;
                if (typeof error.response.data === 'string') {
                    try {
                        errorData = JSON.parse(error.response.data);
                    } catch (e) {
                        errorData = { error: 'Error del servidor' };
                    }
                } else {
                    errorData = error.response.data;
                }
                setError(errorData.error || 'Ocurrió un error. Por favor, inténtalo más tarde.');
            } else {
                setError('Error de red. Por favor, inténtalo más tarde.');
            }
        });
    };

    // Success view after registration
    if (signupSuccess) {
        return (
            <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <PublicNavigation />

                <div style={{ paddingTop: '120px', paddingBottom: '50px' }}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={6} lg={5}>
                                <Card className="shadow-sm">
                                    <Card.Body className="p-4 text-center">
                                        <div className="mb-4">
                                            <div style={{
                                                width: '80px',
                                                height: '80px',
                                                borderRadius: '50%',
                                                backgroundColor: '#28a745',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <span style={{ fontSize: '40px', color: 'white' }}>✉️</span>
                                            </div>
                                        </div>

                                        <h2 className="text-success mb-3">¡Registro Exitoso!</h2>

                                        <Alert variant="info">
                                            <p className="mb-2">
                                                Hemos enviado un correo de verificación a:
                                            </p>
                                            <strong>{registeredEmail}</strong>
                                        </Alert>

                                        <p className="text-muted mb-4">
                                            Por favor revisa tu bandeja de entrada y haz clic en el enlace de verificación para activar tu cuenta.
                                        </p>

                                        <p className="text-muted small mb-3">
                                            ¿No recibiste el correo? Revisa tu carpeta de spam o
                                        </p>

                                        <Button
                                            variant="outline-primary"
                                            onClick={handleResendVerification}
                                            disabled={resendLoading}
                                            className="mb-3"
                                        >
                                            {resendLoading ? 'Enviando...' : 'Reenviar correo de verificación'}
                                        </Button>

                                        {resendMessage && (
                                            <Alert variant="info" className="mt-3">
                                                {resendMessage}
                                            </Alert>
                                        )}

                                        <hr className="my-4" />

                                        <Link to="/login">
                                            <Button variant="link">
                                                Ir a Iniciar Sesión
                                            </Button>
                                        </Link>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <PublicNavigation />

            <div style={{ paddingTop: '100px', paddingBottom: '50px' }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6}>
                            <Card className="shadow-sm">
                                <Card.Body className="p-4">
                                    <h2 className="text-center mb-4">Crea Tu Cuenta</h2>

                                    <Alert variant="success" className="mb-4">
                                        <div className="text-center">
                                            <strong>Primeros 6 meses GRATIS</strong>
                                            <p className="mb-1 mt-2 small">Activa tu empresa sin costo inicial en el plan que corresponda a tu flotilla.</p>
                                            <p className="mb-0 small">Después del periodo gratuito, tu suscripción mensual se ajusta por unidades, módulos y agentes IA.</p>
                                        </div>
                                    </Alert>

                                    <Card className="border-0 bg-light mb-4">
                                        <Card.Body className="p-3">
                                            <h5 className="mb-3 text-primary">Modelo de suscripción</h5>
                                            <Row>
                                                <Col md={4} className="mb-3 mb-md-0">
                                                    <div className="fw-bold">Arranque</div>
                                                    <div className="text-muted small">1 - 5 unidades</div>
                                                    <div>$1,990 MXN / mes*</div>
                                                </Col>
                                                <Col md={4} className="mb-3 mb-md-0">
                                                    <div className="fw-bold">Crecimiento</div>
                                                    <div className="text-muted small">6 - 25 unidades</div>
                                                    <div>$5,490 MXN / mes*</div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="fw-bold">Flota</div>
                                                    <div className="text-muted small">26+ unidades</div>
                                                    <div>Personalizado</div>
                                                </Col>
                                            </Row>
                                            <p className="text-muted small mb-0 mt-3">*Los timbres SAT no están incluidos.</p>
                                            <Link to="/pricing" className="small">Ver detalle de precios</Link>
                                        </Card.Body>
                                    </Card>

                                    {error && <Alert variant="danger">{error}</Alert>}

                                    <Form onSubmit={handleSubmit}>
                                        <h5 className="mb-3 text-primary">Información de la Empresa</h5>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Nombre de la Empresa <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="companyName"
                                                value={formData.companyName}
                                                onChange={handleChange}
                                                required
                                                placeholder="Ingresa el nombre de la empresa"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Razón Social</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="companyLegalName"
                                                value={formData.companyLegalName}
                                                onChange={handleChange}
                                                placeholder="Ingresa la razón social"
                                            />
                                        </Form.Group>

                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Dominio (Subdominio) <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="companyDomain"
                                                        value={formData.companyDomain}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder="miempresa"
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Tu URL será: {formData.companyDomain || 'miempresa'}.kinexion.mx
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>RFC</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="companyTaxId"
                                                        value={formData.companyTaxId}
                                                        onChange={handleChange}
                                                        placeholder="Ingresa el RFC"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Dirección</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="companyAddress"
                                                value={formData.companyAddress}
                                                onChange={handleChange}
                                                placeholder="Ingresa la dirección"
                                            />
                                        </Form.Group>

                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Teléfono de la Empresa</Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        name="companyPhone"
                                                        value={formData.companyPhone}
                                                        onChange={handleChange}
                                                        placeholder="Ingresa el teléfono"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Correo Electrónico de la Empresa</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="companyEmail"
                                                        value={formData.companyEmail}
                                                        onChange={handleChange}
                                                        placeholder="contacto@empresa.com"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Sitio Web</Form.Label>
                                                    <Form.Control
                                                        type="url"
                                                        name="companyWebsite"
                                                        value={formData.companyWebsite}
                                                        onChange={handleChange}
                                                        placeholder="https://www.empresa.com"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Industria</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="companyIndustry"
                                                        value={formData.companyIndustry}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Selecciona una industria</option>
                                                        <option value="Transporte y Logística">Transporte y Logística</option>
                                                        <option value="Manufactura">Manufactura</option>
                                                        <option value="Construcción">Construcción</option>
                                                        <option value="Agricultura">Agricultura</option>
                                                        <option value="Comercio">Comercio</option>
                                                        <option value="Servicios">Servicios</option>
                                                        <option value="Tecnología">Tecnología</option>
                                                        <option value="Otros">Otros</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <hr className="my-4" />

                                        <h5 className="mb-3 text-primary">Información del Usuario Principal</h5>

                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nombre <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="firstName"
                                                        value={formData.firstName}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder="Ingresa tu nombre"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Apellido <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="lastName"
                                                        value={formData.lastName}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder="Ingresa tu apellido"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Correo Electrónico</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                placeholder="Ingresa tu correo electrónico"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Número de Teléfono</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                placeholder="Ingresa tu número de teléfono"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Contraseña</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                required
                                                placeholder="Ingresa tu contraseña (mínimo 8 caracteres)"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-4">
                                            <Form.Label>Confirmar Contraseña</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="confirmPassword"
                                                value={formData.confirmPassword}
                                                onChange={handleChange}
                                                required
                                                placeholder="Vuelve a ingresar tu contraseña"
                                            />
                                        </Form.Group>

                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100 mb-3"
                                            disabled={loading}
                                        >
                                            {loading ? 'Creando Cuenta...' : 'Registrarse'}
                                        </Button>

                                        <div className="text-center">
                                            <span className="text-muted">¿Ya tienes una cuenta? </span>
                                            <Link to="/login">Inicia sesión aquí</Link>
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default withRouter(Signup);
